import { CartItem as CartItemType, usePOSStore } from '../stores/posStore';

interface CartItemProps {
  item: CartItemType;
}

export default function CartItem({ item }: CartItemProps): JSX.Element {
  const removeFromCart = usePOSStore((state) => state.removeFromCart);
  const updateCartQuantity = usePOSStore((state) => state.updateCartQuantity);

  return (
    <div className="bg-white border border-gray-200 rounded-lg p-3">
      <div className="flex justify-between items-start mb-2">
        <div className="flex-1">
          <h3 className="font-semibold text-gray-900">{item.product.name}</h3>
          <p className="text-sm text-gray-600">₦{item.price}</p>
        </div>
        <button
          onClick={() => removeFromCart(item.productId)}
          className="text-red-600 hover:text-red-700 text-sm font-medium"
        >
          Remove
        </button>
      </div>
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <button
            onClick={() => updateCartQuantity(item.productId, item.quantity - 1)}
            className="bg-gray-200 text-gray-700 w-8 h-8 rounded hover:bg-gray-300 transition-colors"
          >
            −
          </button>
          <span className="w-8 text-center font-semibold">{item.quantity}</span>
          <button
            onClick={() => updateCartQuantity(item.productId, item.quantity + 1)}
            className="bg-gray-200 text-gray-700 w-8 h-8 rounded hover:bg-gray-300 transition-colors"
          >
            +
          </button>
        </div>
        <span className="font-bold text-blue-600">₦{(item.price * item.quantity).toFixed(2)}</span>
      </div>
    </div>
  );
}
